import {CheckInFormValues, validateRequiredContainerNumber, validateRequiredDriverFirstName, validateRequiredDriverLastName, validateRequiredDriverLicenseNumber, validateRequiredAssetSize, validateRequiredChassisNumber, validateOptionalScacCode} from '../../util/check-in-field-validation';

/**
 * Validates the default fields for Empty Container check-in.
 * Covers: CONTAINER_EMPTY, TRUCK_CONTAINER_EMPTY.
 * Required: containerNumber, driverFirstName, driverLastName,
 *           driverLicenseNumber, assetSize, chassisNumber.
 */
export const validateEmptyContainerForm = (values: CheckInFormValues): string | undefined =>
  validateRequiredContainerNumber(values.containerNumber) ??
  validateRequiredDriverFirstName(values.driverFirstName) ??
  validateRequiredDriverLastName(values.driverLastName) ??
  validateRequiredDriverLicenseNumber(values.driverLicenseNumber) ??
  validateRequiredAssetSize(values.assetSize) ??
  validateRequiredChassisNumber(values.chassisNumber) ??
  validateOptionalScacCode(values.scacCode);
